import React, { FC } from "react";
import { NavLink } from "react-router-dom";

import { Button, Icon } from "../../../components/common";
import { ProfileMenu } from "../../menu";
import { ROUTES } from "../../../routes";

export const ProfileSidebar: FC = () => {
  return (
    <div className="flex flex-col">
      <Button
        className="mb-12"
        rounded
        component={NavLink}
        to={ROUTES.HOME}
        data-test="back-to-dashboard-btn"
      >
        <span className="flex flex-row items-center justify-start gap-x-6 font-manrope text-base whitespace-nowrap">
          <Icon icon="Arch" size={24} className="text-gray-500" disableFill />
          Back to dashboard
        </span>
      </Button>

      <ProfileMenu />
    </div>
  );
};
